<template>
  <!-- 组装拆分单 -->
  <div class="make-up-order-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="单据编号" @keydown.enter="resetSearch">
            <template #prefix>单据编号</template>
          </el-input>
          <el-select v-model="searchInfo.outWarehouseId" placeholder="请选择仓库" clearable filterable>
            <template #prefix>出库仓库</template>
            <el-option v-for="w in warehouseList" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
          <el-select v-model="searchInfo.inWarehouseId" placeholder="请选择仓库" clearable filterable>
            <template #prefix>入库仓库</template>
            <el-option v-for="w in warehouseList" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
          <employee-select v-model="searchInfo.operatorId" placeholder="请选择操作员">
            <template #prefix>操作员</template>
          </employee-select>
          <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
            <template #prefix>状态</template>
            <el-option label="草稿" :value="3001"/>
            <el-option label="已提交" :value="3010"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="$router.push('/stock/makeUp/detail')">新建组装拆分单</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="makeUpOrderList">
          <yq-table-column label="单据编号" prop="billNo" width="180rem">
            <template v-slot="{row}">
              <a @click="toDetail(row)">{{row.billNo}}</a>
            </template>
          </yq-table-column>
          <yq-table-column label="出库仓库" prop="outWarehouseName" min-width="150rem">
            <template v-slot="{row}">{{getWarehouseName(row.outWarehouseId)}}</template>
          </yq-table-column>
          <yq-table-column label="入库仓库" prop="inWarehouseName" min-width="150rem">
            <template v-slot="{row}">{{getWarehouseName(row.inWarehouseId)}}</template>
          </yq-table-column>
          <yq-table-column label="操作员" prop="operatorName" width="120rem"/>
          <yq-table-column label="单据日期" prop="billDate" width="150rem" class-name="muted">
            <template v-slot="{row}">{{row.billDate? row.billDate.substring(0,10): '-'}}</template>
          </yq-table-column>
          <yq-table-column label="单据来源" prop="sourceTypeName" width="150rem" />
          <yq-table-column label="创建时间" prop="createdTime" :show-overflow-tooltip="true"/>
          <yq-table-column label="状态" prop="status" width="120rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.status === 3001 ? 'warning' : 'success'">{{row.statusName}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toDetail(row)">详情</table-button>
                <table-button v-if="row.status === 1" type="delete" el-type="danger" message="是否确认删除该组装拆分单" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import assemblyOrderApi from "@/api/normal/stock/assemblyOrderApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MakeUpOrderList",
  components: {
    EmployeeSelect,
    YqTableColumn, TableButtonGroup, TableButton,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1},
      dataList: [],
      warehouseList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
    commonDataApi.queryAllWarehouse().then(list => this.warehouseList = list);
  },
  methods: {
    // 显示仓库名称
    getWarehouseName(id) {
      for (let i = 0; i < this.warehouseList.length; i++) {
        if (this.warehouseList[i].id === id) {
          return this.warehouseList[i].warehouseName;
        }
      }
      return "";
    },
    async queryList() {
      const {records, totalCount} = await assemblyOrderApi.queryList(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toDetail(row) {
      this.router.push(`/stock/makeUp/detail?id=${row.id}`);
    },
    async toDelete(row) {
      await assemblyOrderApi.delete(row.id);
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.make-up-order-list {
  height: 100%;
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
